import React, { useState } from 'react';
import { Popconfirm } from 'antd';
import { SSO } from 'src/_shared/index.js';

const CognitoTroubleshooterCard = (props) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [companyId, setCompanyId] = useState(props?.currentUser?.companyId || '');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);

  const handleSubmit = async () => {
    if (!username && !email) {
      alert('Please enter a Username or Email');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const body = {
        type: 'troubleshootSSOUser',
        companyId: companyId,
        email: email || null,
        username: username || null,
        options: {}
      };

      // Using SSO function from your imports
      const response = await SSO(body);
      
      setResult(response);

    } catch (error) {
      console.error('Error:', error);
      setResult({
        status: 'error',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setEmail('');
    setUsername('');
    setResult(null);
  };

  const handleDeleteUser = async (user) => {
    setDeletingUser(user.username);
    try {
      const body = {
        type: 'troubleshootSSOUser',
        companyId: companyId,
        email: email,
        username: user.username,
        options: {
          userToDelete: user.username
        }
      };

      const response = await SSO(body);

      if (response.ok) {
        const data = await response.json();
        if (data.status === 'deleted') {
          // Remove the user from the results
          setResult(prevResult => ({
            ...prevResult,
            users: prevResult.users.filter(u => u.username !== user.username),
            count: prevResult.count - 1
          }));
          alert('User deleted successfully');
        } else {
          alert('Failed to delete user: ' + (data.message || 'Unknown error'));
        }
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      alert('Error deleting user: ' + error.message);
    } finally {
      setDeletingUser(null);
    }
  };

  const renderUserCard = (user, index) => {
    const isSamlUser = user.username.includes('_') && !user.username.includes('Google_');
    const isDeleting = deletingUser === user.username;
    
    return (
      <tr 
        key={index} 
        style={{ 
          borderBottom: index < (result?.users?.length || 0) - 1 ? '1px solid #f0f0f0' : 'none'
        }}
        onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#fafafa'}
        onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
      >
        <td style={{ padding: '12px 16px', fontSize: '14px', fontWeight: '500' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ padding: '12px 16px', fontSize: '14px' }}>
                {user?.attributes?.['custom:userId'] ? (
                    <a href={`/employees/${user.attributes['custom:userId']}`}>
                        {user.username}
                    </a>
                ) : user.username}
            </span>
            {isSamlUser && (
              <span style={{
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: '500',
                backgroundColor: '#1890ff',
                color: 'white'
              }}>
                SAML
              </span>
            )}
          </div>
        </td>
        <td style={{ padding: '12px 16px', fontSize: '14px' }}>
            {user.userPoolId}
        </td>
        <td style={{ padding: '12px 16px', fontSize: '14px' }}>
          {user.attributes?.identities?.[0]?.providerName || '-'}
        </td>
        <td style={{ padding: '12px 16px' }}>
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: user.enabled ? '#52c41a' : '#ff4d4f',
            color: 'white'
          }}>
            {user.enabled ? 'Enabled' : 'Disabled'}
          </span>
        </td>
        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#666' }}>
          {user.created ? new Date(user.created).toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          }) : '-'}
        </td>
        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#666' }}>
          {user.modified ? new Date(user.modified).toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          }) : '-'}
        </td>
        <td style={{ padding: '12px 16px', textAlign: 'center' }}>
          <button
            onClick={() => setSelectedUser(user)}
            style={{
              padding: '6px 12px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#40a9ff'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#1890ff'}
          >
            View Details
          </button>
        </td>
      </tr>
    );
  };

  const renderResult = () => {
    if (!result) return null;

    return (
      <div style={{ marginTop: '24px' }}>
        <h3 style={{ 
          margin: '0 0 16px 0', 
          fontSize: '18px', 
          fontWeight: '600',
          color: '#333'
        }}>
          Search Results
        </h3>
        
        {result.status === 'error' && (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '2px solid #ff4d4f'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              color: '#ff4d4f',
              fontSize: '16px',
              fontWeight: '600'
            }}>
              <span style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: '#ff4d4f',
                borderRadius: '50%'
              }}></span>
              Error Occurred
            </div>
            <div style={{ 
              marginTop: '12px', 
              fontSize: '14px', 
              color: '#666'
            }}>
              {result.message}
            </div>
          </div>
        )}

        {result.status === 'not_found' && (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '2px solid #1890ff'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              color: '#1890ff',
              fontSize: '16px',
              fontWeight: '600'
            }}>
              <span style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: '#1890ff',
                borderRadius: '50%'
              }}></span>
              No Users Found
            </div>
            <div style={{ 
              marginTop: '12px', 
              fontSize: '14px', 
              color: '#666'
            }}>
              {result.message}
            </div>
          </div>
        )}

        {result.status === 'deleted' && (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '2px solid #52c41a'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              color: '#52c41a',
              fontSize: '16px',
              fontWeight: '600'
            }}>
              <span style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: '#52c41a',
                borderRadius: '50%'
              }}></span>
              User Deleted Successfully
            </div>
            <div style={{ 
              marginTop: '12px', 
              fontSize: '14px', 
              color: '#666'
            }}>
              {result.message}
            </div>
          </div>
        )}

        {result.status === 'found' && (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '2px solid #52c41a'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              marginBottom: '20px',
              color: '#52c41a',
              fontSize: '16px',
              fontWeight: '600'
            }}>
              <span style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: '#52c41a',
                borderRadius: '50%'
              }}></span>
              Found {result.count} User(s)
            </div>

            <div style={{ overflowX: 'auto', border: '1px solid #e8e8e8', borderRadius: '6px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' }}>
                <thead>
                  <tr style={{ backgroundColor: '#fafafa' }}>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'left',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Username
                    </th>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'left',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      User Pool ID
                    </th>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'left',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Provider
                    </th>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'left',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Status
                    </th>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'left',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Created
                    </th>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'left',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Last Modified
                    </th>
                    <th style={{
                      padding: '12px 16px',
                      textAlign: 'center',
                      borderBottom: '1px solid #e8e8e8',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {result.users.map((user, index) => renderUserCard(user, index))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ 
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      {/* CSS Animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '10px'
      }}>
        {/* Header */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          marginBottom: '24px' 
        }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#333' }}>
            Cognito User Search
          </h2>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                padding: '8px 16px',
                backgroundColor: loading ? '#f5f5f5' : '#1890ff',
                color: loading ? '#999' : 'white',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {loading ? (
                <>
                  <span style={{
                    display: 'inline-block',
                    width: '12px',
                    height: '12px',
                    border: '2px solid #999',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></span>
                  Searching...
                </>
              ) : (
                <>Search Users</>
              )}
            </button>
            
            <button
              onClick={handleClear}
              style={{
                padding: '8px 16px',
                backgroundColor: '#f5f5f5',
                color: '#333',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              Clear
            </button>
          </div>
        </div>
        
        {/* Form Section */}
        <div style={{ 
          marginBottom: '24px',
          padding: '20px',
          backgroundColor: '#fafafa',
          borderRadius: '6px',
          border: '1px solid #e8e8e8'
        }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '16px',
            marginBottom: '16px'
          }}>
            <div>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px', 
                fontWeight: '500',
                color: '#333'
              }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                //placeholder="e.g., username@erinapp.com"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  fontSize: '14px',
                  backgroundColor: 'white'
                }}
              />
            </div>
            
            <div>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px', 
                fontWeight: '500',
                color: '#333'
              }}>
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                //placeholder="Username (leave empty to search by email)"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  fontSize: '14px',
                  backgroundColor: 'white'
                }}
              />
            </div>
          </div>
        </div>

        {renderResult()}
        
        {/* User Attributes Modal */}
        {selectedUser && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '600px',
              maxHeight: '80vh',
              overflowY: 'auto',
              boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
              position: 'relative',
              width: '100%'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#333' }}>
                  User Details - {selectedUser.username}
                </h3>
                <div style={{ display: 'flex', gap: '12px' }}>
                    {selectedUser.username.includes('_') && !selectedUser.username.includes('Google_') && (
                    <Popconfirm
                        title={`Are you sure you want to delete user "${selectedUser.username}"? This action cannot be undone.`}
                        placement="bottom"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => handleDeleteUser(selectedUser)}
                    >
                        <button
                        disabled={deletingUser === selectedUser.username}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: (deletingUser === selectedUser.username) ? '#f5f5f5' : '#ff4d4f',
                            color: (deletingUser === selectedUser.username) ? '#999' : 'white',
                            border: '1px solid #d9d9d9',
                            borderRadius: '4px',
                            cursor: (deletingUser === selectedUser.username) ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                        >
                        {deletingUser === selectedUser.username ? (
                            <>
                            <span style={{
                                display: 'inline-block',
                                width: '12px',
                                height: '12px',
                                border: '2px solid #999',
                                borderTop: '2px solid transparent',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }}></span>
                            Deleting...
                            </>
                        ) : (
                            'Delete User'
                        )}
                        </button>
                    </Popconfirm>
                  )}
                  <button
                    onClick={() => setSelectedUser(null)}
                    style={{
                      padding: '8px 12px',
                      backgroundColor: '#f5f5f5',
                      border: '1px solid #d9d9d9',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>

              <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: '#333' }}>
                User Attributes
              </h4>
              
              {selectedUser.attributes ? (
                <div style={{ 
                  padding: '16px',
                  backgroundColor: '#fafafa',
                  borderRadius: '6px',
                  border: '1px solid #e8e8e8'
                }}>
                  {Object.entries(selectedUser.attributes).map(([key, value]) => (
                    <div key={key} style={{ 
                      marginBottom: '12px',
                      paddingBottom: '12px',
                      borderBottom: '1px solid #e8e8e8'
                    }}>
                      <div style={{ 
                        fontSize: '14px', 
                        fontWeight: '600', 
                        color: '#333',
                        marginBottom: '4px'
                      }}>
                        {key}:
                      </div>
                      <div style={{ 
                        fontSize: '13px', 
                        color: '#666',
                        backgroundColor: 'white',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #e8e8e8',
                        wordBreak: 'break-all'
                      }}>
                        {typeof value === 'object' ? (
                          <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '12px' }}>
                            {JSON.stringify(value, null, 2)}
                          </pre>
                        ) : (
                          value
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '40px', 
                  color: '#999',
                  fontSize: '16px'
                }}>
                  No attributes available for this user.
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CognitoTroubleshooterCard;